module.exports = __webpack_public_path__ + "build/desktop/img/profile.083f998ce2094b53a9d61c7efa0f6c19.svg";